import React, { useState } from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { Phone, Mail, MapPin, Instagram, Send } from 'lucide-react';
export function Contact() {
  const [formState, setFormState] = useState<'idle' | 'submitting' | 'success'>('idle');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setFormState('submitting');
    // Simulate API call
    setTimeout(() => {
      setFormState('success');
    }, 1500);
  };
  return <Section id="contact" background="default" data-id="element-8" data-mp="3ovmewryl26ti">
      <div className="grid lg:grid-cols-2 gap-12 lg:gap-24" data-id="element-9" data-mp="3owxt7lpnmwyv">
        <div data-id="element-10" data-mp="3k4mgtjdq9ipf">
          <h2 className="text-3xl md:text-4xl font-bold text-[#2c2c2c] mb-6" data-id="element-11" data-mp="3k44pn15x9uod">
            Ready to get started?
          </h2>
          <p className="text-lg text-[#525252] mb-10" data-id="element-12" data-mp="3f62x7pmlwj08">
            Fill out the form or give us a call. We'll get back to you within 24
            hours to discuss your project.
          </p>

          <div className="space-y-8" data-id="element-13" data-mp="bob9wojf0n8d">
            <a href="tel:5036068823" className="flex items-start gap-4 group" data-id="element-14" data-mp="3jvut6fcuthvb">
              <div className="w-12 h-12 rounded-full bg-[#ff6b35]/10 flex items-center justify-center text-[#ff6b35] group-hover:bg-[#ff6b35] group-hover:text-white transition-colors" data-id="element-15" data-mp="3jxxggrmmgwwc">
                <Phone className="h-6 w-6" data-id="element-16" data-mp="3b16nwp7a406i" />
              </div>
              <div data-id="element-17" data-mp="3f3t9479g2muq">
                <h3 className="font-bold text-[#2c2c2c] text-lg" data-id="element-18" data-mp="3f3bax5381yk6">Call Us</h3>
                <p className="text-[#525252]" data-id="element-19" data-mp="3141wa9unzcib">(503) 606-8823</p>
                <p className="text-sm text-gray-400 mt-1" data-id="element-20" data-mp="363wpwl5tqg72">Mon-Fri, 8am - 6pm</p>
              </div>
            </a>

            <a href="mailto:fixandfinishpdx@gmail.com" className="flex items-start gap-4 group" data-id="element-21" data-mp="2s4x3lk5sade2">
              <div className="w-12 h-12 rounded-full bg-[#ff6b35]/10 flex items-center justify-center text-[#ff6b35] group-hover:bg-[#ff6b35] group-hover:text-white transition-colors" data-id="element-22" data-mp="2w6ii19xyuzqd">
                <Mail className="h-6 w-6" data-id="element-23" data-mp="udcb5iwbyvsn" />
              </div>
              <div data-id="element-24" data-mp="23bc02u2qpzur">
                <h3 className="font-bold text-[#2c2c2c] text-lg" data-id="element-25" data-mp="23cn5szfqxhoi">Email Us</h3>
                <p className="text-[#525252]" data-id="element-26" data-mp="1ybzh4kezpcxg">fixandfinishpdx@gmail.com</p>
              </div>
            </a>

            <div className="flex items-start gap-4" data-id="element-27" data-mp="1ua45alzfnh5f">
              <div className="w-12 h-12 rounded-full bg-[#ff6b35]/10 flex items-center justify-center text-[#ff6b35]" data-id="element-28" data-mp="1ud05kgyr6hx1">
                <MapPin className="h-6 w-6" data-id="element-29" data-mp="2m223ql04xqoo" />
              </div>
              <div data-id="element-30" data-mp="2m1a9bdi9xyzz">
                <h3 className="font-bold text-[#2c2c2c] text-lg" data-id="element-31" data-mp="2m3wfb8pio6g3">
                  Service Area
                </h3>
                <p className="text-[#525252] mb-2" data-id="element-32" data-mp="2d9i53kjufm3u">
                  Proudly serving the greater Portland Metro area and
                  surrounding communities throughout Oregon:
                </p>
                <p className="text-sm text-[#525252] leading-relaxed" data-id="element-33" data-mp="35psvdm7zgwag">
                  Portland, Beaverton, Tigard, Lake Oswego, Hillsboro, Gresham,
                  Milwaukie, Oregon City, West Linn, Tualatin, Wilsonville,
                  Sherwood, Clackamas, Happy Valley, Aloha, Troutdale, Wood
                  Village, Fairview, Damascus, Gladstone, and more.
                </p>
              </div>
            </div>

            <a href="https://instagram.com/fixandfinish_pdx" target="_blank" rel="noopener noreferrer" className="flex items-start gap-4 group" data-id="element-34" data-mp="3i7lnl6zsdqnn">
              <div className="w-12 h-12 rounded-full bg-[#ff6b35]/10 flex items-center justify-center text-[#ff6b35] group-hover:bg-[#ff6b35] group-hover:text-white transition-colors" data-id="element-35" data-mp="3r8tn1se1gxjb">
                <Instagram className="h-6 w-6" data-id="element-36" data-mp="4v37mahs73kf" />
              </div>
              <div data-id="element-37" data-mp="9slgk0vstisf">
                <h3 className="font-bold text-[#2c2c2c] text-lg" data-id="element-38" data-mp="9rtm4tdxtr3q">Follow Us</h3>
                <p className="text-[#525252]" data-id="element-39" data-mp="duyomvy0pssd">@fixandfinish_pdx</p>
              </div>
            </a>
          </div>
        </div>

        <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100" data-id="element-40" data-mp="iub95a1f2nrs">
          {formState === 'success' ? <div className="h-full flex flex-col items-center justify-center text-center py-12" data-id="element-41" data-mp="54zqdkjwhuhf">
              <div className="w-16 h-16 bg-green-100 text-green-600 rounded-full flex items-center justify-center mb-6" data-id="element-42" data-mp="14z6hke18r2z">
                <Send className="h-8 w-8" data-id="element-43" data-mp="9xj6op9z33px" />
              </div>
              <h3 className="text-2xl font-bold text-[#2c2c2c] mb-2" data-id="element-44" data-mp="9y2o84vpnq3f">
                Message Sent!
              </h3>
              <p className="text-[#525252]" data-id="element-45" data-mp="3iffc1ktq02a4">
                Thanks for reaching out. We'll be in touch shortly.
              </p>
              <Button variant="outline" className="mt-8" onClick={() => setFormState('idle')} data-id="element-46" data-mp="3sb8z3y52fe65">
                Send another message
              </Button>
            </div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-47" data-mp="17jqcu3lxd44e">
              <h3 className="text-2xl font-bold text-[#2c2c2c] mb-6" data-id="element-48" data-mp="12mzuf9mndwft">
                Send a Message
              </h3>

              <div className="grid sm:grid-cols-2 gap-6" data-id="element-49" data-mp="2kj1tpqyol5hv">
                <div className="space-y-2" data-id="element-50" data-mp="2pio6y0eielqo">
                  <label htmlFor="name" className="text-sm font-medium text-[#2c2c2c]" data-id="element-51" data-mp="2pkhh3pobzo3f">
                    Name
                  </label>
                  <input id="name" required type="text" className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-[#17a2b8] focus:ring-2 focus:ring-[#17a2b8]/20 outline-none transition-all" placeholder="John Doe" data-id="element-52" data-mp="2girqun66qv78" />
                </div>
                <div className="space-y-2" data-id="element-53" data-mp="2zgaqj06r71gz">
                  <label htmlFor="phone" className="text-sm font-medium text-[#2c2c2c]" data-id="element-54" data-mp="2zeznx3p1nzrg">
                    Phone
                  </label>
                  <input id="phone" required type="tel" className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-[#17a2b8] focus:ring-2 focus:ring-[#17a2b8]/20 outline-none transition-all" placeholder="(503) 606-8823" data-id="element-55" data-mp="3rzhqfng3sorv" />
                </div>
              </div>

              <div className="space-y-2" data-id="element-56" data-mp="3my7cu7sbjipo">
                <label htmlFor="email" className="text-sm font-medium text-[#2c2c2c]" data-id="element-57" data-mp="3iv1b9dg5ifpj">
                  Email
                </label>
                <input id="email" required type="email" className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-[#17a2b8] focus:ring-2 focus:ring-[#17a2b8]/20 outline-none transition-all" placeholder="john@example.com" data-id="element-58" data-mp="394gdttc7rh87" />
              </div>

              <div className="space-y-2" data-id="element-59" data-mp="2v71kidiuapay">
                <label htmlFor="service" className="text-sm font-medium text-[#2c2c2c]" data-id="element-60" data-mp="1anfntte3kd4y">
                  Service Needed
                </label>
                <select id="service" className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-[#17a2b8] focus:ring-2 focus:ring-[#17a2b8]/20 outline-none transition-all bg-white" data-id="element-61" data-mp="1jn2qsjmh5r04">
                  <option data-id="element-62" data-mp="r0qb57qdye66">General Repair</option>
                  <option data-id="element-63" data-mp="vxgrlw63rbs4">Maintenance</option>
                  <option data-id="element-64" data-mp="vy9nu37fqiw0">Small Remodel</option>
                  <option data-id="element-65" data-mp="10wl0elp477hx">Emergency Service</option>
                  <option data-id="element-66" data-mp="10vs1u80b7oav">Other</option>
                </select>
              </div>

              <div className="space-y-2" data-id="element-67" data-mp="15pe3l54xq7rw">
                <label htmlFor="message" className="text-sm font-medium text-[#2c2c2c]" data-id="element-68" data-mp="88fcjq2rl2dv">
                  Message
                </label>
                <textarea id="message" required rows={4} className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-[#17a2b8] focus:ring-2 focus:ring-[#17a2b8]/20 outline-none transition-all resize-none" placeholder="Tell us about your project..." data-id="element-69" data-mp="d55vqm9v8e3i"></textarea>
              </div>

              <Button type="submit" className="w-full" size="lg" isLoading={formState === 'submitting'} data-id="element-70" data-mp="3log97lwc931w">
                Send Message
              </Button>
            </form>}
        </div>
      </div>
    </Section>;
}